import { partial } from '../../utils/utils';
import { parseFolders } from './parsers/folders';
import { toError } from './parsers/error';
export function initFolders(settings, http) {
  function list(folderId, options) {
    if (folderId) {
      // DeviantArt does not support requesting sub-folders. It returns flat list of all folders (including nested folders).
      return Promise.resolve({
        data: []
      });
    }
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      limit: options.paging.size || settings.foldersLimit,
      offset: options.paging.cursor || null
    };
    return http.get("" + settings.apiUrl + settings.apiPath + "/gallery/folders", requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(partial(parseFolders, settings)).then(res => ({
      ...res,
      data: res.data.map(folder => ({
        ...folder,
        parentId: folderId
      }))
    })).catch(toError);
  }
  return {
    list
  };
}